/**
 * GMCC Specials → Universe（/app/gmccuniverserates）。
 * STATSIG.UNIVERSE.SEARCH → UNIVERSE_SEARCH
 *
 * 打开页面只是空表单，不算。
 * 点 Check rates 出结果才打 SEARCH。
 * Celebrity、PPE Rates 不跨到这里。
 */
export enum GmccUniverseEvent {
    /** 询价出结果 */
    SEARCH = 'UNIVERSE_SEARCH',
}
